import { Component, Input, ViewChild, ElementRef } from '@angular/core';
import { DashboardService } from 'app/shared/services/dashboard/dashboard.service';
import { LoaderButton } from 'app/shared/components/loader-button/loader-button.component';

@Component({
  selector: 'tog-whats-new',
  templateUrl: 'dashboard-whats-new.template.html',
  styleUrls: ['dashboard-whats-new.scss']
})
export class DashboardWhatsNew {
  articleToView: any;
  articleToDelete: any;
  hoverArticle: any;

  @Input() adminMode: boolean = false;

  @ViewChild('whatsNewModalButton') whatsNewModalButton: ElementRef;
  @ViewChild('confirmWhatsNewButton') confirmWhatsNewButton: LoaderButton;
  @ViewChild('deleteArticleButton') deleteArticleButton: ElementRef;
  @ViewChild('confirmDeleteButton') confirmDeleteButton: LoaderButton;
  @ViewChild('openArticleButton') openArticleButton: ElementRef;

  constructor(public dashboardService: DashboardService) {
  }

  addNewsItem() {
    this.dashboardService.resetForm();
    this.whatsNewModalButton.nativeElement.click();
  }

  editNewsItem(article: any) {
    this.dashboardService.editNewsItem(article);
    this.whatsNewModalButton.nativeElement.click();
  }

  confirmSaveProductChange() {
    this.dashboardService.confirmSaveProductChange()
    .then(() => {
      this.confirmWhatsNewButton.setConfirmed();
    })
    .catch((e) => {
      this.confirmWhatsNewButton.setInactive();
    });
  }

  deleteNewsItem(article: any) {
    this.articleToDelete = article;
    this.deleteArticleButton.nativeElement.click();
  }

  confirmDelete() {
    this.dashboardService.deleteWhatsNew(this.articleToDelete.id)
      .then((res) => {
        this.confirmDeleteButton.setConfirmed();
      })
      .catch((e) => {
        this.confirmDeleteButton.setInactive();
      });
  }

  openArticleModal(articleMap: any) {
    this.dashboardService.updateUserReadStates(articleMap);
    this.articleToView = articleMap.article;
    if (articleMap.article.description.length > 58) this.openArticleButton.nativeElement.click();
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/components/dashboard-whats-new/dashboard-whats-new.component.ts